import { Entities } from "./entities";

function menuToggle() {
    const dropdown = document.querySelector('.info-template__dropdown');
    const overlay = document.querySelector('.info-template__dropdown-overlay');

    // for iPhone
    document.documentElement.classList.toggle('prevent-scroll-knowledge-sidebar');
    document.body.classList.toggle('prevent-scroll-knowledge-sidebar');

    dropdown?.classList.toggle('info-template__dropdown_active')
    overlay?.classList.toggle('info-template__dropdown-overlay_active')
}

export class InfoTemplateDropdown {
    constructor() {
        new Entities('.info-template__dropdown-overlay', menuToggle);
        new Entities('.info-template__dropdown-button', menuToggle);
    }
}
